<template>
	<v-card>
		<!-- <v-toolbar>
			<v-spacer></v-spacer>
		</v-toolbar>-->
		<brace
			style="height:90vh;"
			class="kbet-editor"
			:mode="'json'"
			@code-change="onEditorCodeChange"
			@setHandler="
				h => {
					editorHandler = h;
				}
			"
		/>
	</v-card>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {},
	created() {},
	data() {
		return {
			editorHandler: false,
		};
	},
	methods: {
		...mapActions('rejectedMeta', [
			'verifyMeta',
			'extractAndSaveMeta',
			'getFileMeta',
		]),
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		...mapMutations('rejectedMeta', [
			'refreshStockistListEmitter',
			'closeFileMetaDialog',
		]),
		// ...mapMutations("rejectedMeta", ["closeFileMetaDialog"]),
		onEditorCodeChange(code) {
			this.editorCode = code;
		},
	},
	computed: {
		...mapGetters(['getSelectedDates']),
		...mapGetters('rejectedMeta', ['selectedFile']),
	},
	mounted() {
		this.getFileMeta(this.selectedFile.metaUsed).then(data => {
			if (data.ok) {
				this.editorHandler.setValue(JSON.stringify(data.meta, null, 2));
			}
		});
	},
};
</script>

<style lang="scss" scoped></style>
